import { Skeleton } from "@mui/material";

const SkeletonCard = () => {
  return (
    <div className="w-full rounded-xl bg-white shadow-md px-3 py-5 text-sm mb-4">
      <Skeleton 
        variant="text" 
        width="60%" 
        height={28} 
        className="mb-4"
      />
      
      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <Skeleton variant="text" width={80} height={20} />
          <Skeleton variant="text" width={100} height={20} />
        </div>
        
        <div className="flex items-center justify-between">
          <Skeleton variant="text" width={100} height={20} />
          <Skeleton variant="text" width={120} height={20} />
        </div>
        
        <div className="flex items-center justify-between">
          <Skeleton variant="text" width={80} height={20} />
          <Skeleton variant="text" width={150} height={20} />
        </div>
        
        <div className="flex items-center justify-between">
          <Skeleton variant="text" width={120} height={20} />
          <Skeleton variant="text" width={40} height={20} />
        </div>
        
        <div className="flex items-center justify-between">
          <Skeleton variant="text" width={120} height={20} />
          <Skeleton variant="text" width={40} height={20} />
        </div>
        
        <div className="flex items-center justify-between">
          <Skeleton variant="text" width={100} height={20} />
          <Skeleton variant="text" width={80} height={20} />
        </div>
        
        <div className="flex items-center justify-between">
          <Skeleton variant="text" width={80} height={20} />
          <Skeleton variant="text" width={40} height={20} />
        </div>
        
        <div className="flex items-center justify-between">
          <Skeleton variant="text" width={60} height={20} />
          <Skeleton 
            variant="rectangular" 
            width={44} 
            height={24} 
            className="rounded-full"
          />
        </div>
      </div>
      
      <div className="flex gap-4 mt-6">
        <Skeleton 
          variant="rectangular" 
          width="50%" 
          height={40} 
          className="rounded-lg"
        />
        <Skeleton 
          variant="rectangular" 
          width="50%" 
          height={40} 
          className="rounded-lg"
        />
      </div>
    </div>
  );
};

export default SkeletonCard;
